import { PageContainer } from "@/features/ui";

import { apiClient, getErrorMessage } from "@/features/shared";
import { WarehouseForm } from "@/features/warehouses/warehouse-form";
import { useSnackbar } from "@/features/ui";
import { useNavigate } from "react-router-dom";

import { Button } from "@mui/material";

export const CreateWarehouse = () => {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async (formData) => {
    try {
      await apiClient.post("warehouses", formData);
      navigate(-1);
    } catch (error) {
      showSnackbar(
        getErrorMessage(error, "Gagal membuat gudang")
      );
    }
  };

  return (
    <PageContainer
      maxWidth="xl"
      title="Tambah Gudang"
      breadcrumbs={[
        { title: "Gudang", path: "/inventory/warehouses" },
        { title: "Tambah" },
      ]}
    >
      <WarehouseForm
        onSubmit={handleSubmit}
        renderActionButton={({ isLoading }) => (
          <Button type="submit" variant="contained" loading={isLoading}>
            Tambah
          </Button>
        )}
      />
    </PageContainer>
  );
};
